import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import FeedLogo from "../../FeedPost/component/FeedLogo";
import FeedButton from "../../FeedPost/component/FeedButton";
import {
  FlashMessage,
  Modal,
  ErrorTextHelper,
  Button,
  RichTextEditor,
  ConfirmDialog,
} from "../../../../components/common";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { rootReducersState } from "../../../../reducers";
import { ReducerFlag } from "../../../../types/reducer.types";
import {
  deletePostFlagReset,
  updatePostFlagReset,
  editFeedRequest,
  deleteFeedRequest,
} from "../../../../reducers/feeds/feedPost.reducer";
// import { ReactComponent as DeleteIcon } from "../../../../assets/svg/delete-icon.svg";
import dots from "../../../../assets/svg/dots.svg";
import cameraIcon from "../../../../assets/svg/camera.svg";
import Image from "../../../../components/common/Image";
import {
  convertUTCToLocal,
  stripHTMLTags,
  uuid,
} from "../../../../utils/helper";
import history from "../../../../utils/history";
import appRoutes from "../../../../routes/app.routes";
import { openUrlInNewTab } from "../../../../utils/helper";
import Report from "../../../../components/common/Report";
import ReactPlayer from "react-player";
import { Cancel as CancelOut } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
interface FeedListTypes {
  data: any;
  loading?: boolean;
  [key: string]: any;
  index?: any;
}

interface MediaAsset {
  id: string;
  media_type: "image" | "video";
  media_thumbnail: string;
  media_original: string;
  thumbnails?: string[];
  selectedCover?: string;
  loadingThumbnails?: boolean; 
  thumbnailsGenerated?: boolean;
  thumbnailsCacheKey?: string; // For cache invalidation
}

// TODO - recreate this, keep only listing part, rest take out side of the modal, recreating the each and every modal instance
const FeedBodyHeader = ({ data, index }: FeedListTypes) => {
  const dispatch = useDispatch();
  const {
    editLoading,
    deleteMessage,
    updateFlag,
    updateMessage,
    deleteLoading,
    deleteflag,
    deletePostType,
  } = useSelector(({ postFeed }: rootReducersState) => postFeed.postFeed);
  const currentUser = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );
  const [feedMore, setFeedMore] = useState<boolean>(false);
  const [openEditFeedModal, setOpenEditFeedModal] = useState<boolean>(false);
  const [closeEditModal, setCloseEditModal] = useState<boolean>(false);
  const [openDeleteFeedModal, setOpenDeleteFeedModal] =
    useState<boolean>(false);
  const [updatedAssets, setUpdatedAssets] = useState<
    {
      id: string;
      file: Blob;
    }[]
  >([]);
  // const [postMedia, setPostMedia] = useState(data.post_media);
  const [postMedia, setPostMedia] = useState<MediaAsset[]>(() =>
    data.post_media.map((m: any) => ({
      id: m.id,
      media_type: m.media_type,
      media_thumbnail: m.media_thumbnail,
      media_original: m.media_original,
      // if the server already has a cover, seed thumbnails + selectedCover
      thumbnails: m.selectedCover ? [m.selectedCover] : undefined,
      selectedCover: m.selectedCover,
      loadingThumbnails: false 
    }))
  );

  const [deleteMedia, setDeleteMedia] = useState<string[]>([]);
  const [postTextLength, setPostTextLength] = useState<number>(0);
  const [openReport, setOpenReport] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );
  const [coverModalOpen, setCoverModalOpen] = useState(false);

  const postId = data?.id;
  // const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  const form = useForm<FeedListTypes>({
    defaultValues: { post_text: data.content || data.post_text },
  });
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
  } = form;

  const postText = watch("post_text", "");
  const postType = data.post_type;

  // Check the content length
  useEffect(() => {
    const tmpText = stripHTMLTags(postText);
    setPostTextLength(tmpText.length);
  }, [postText]);

  useEffect(() => {
    reset({ post_text: data.content });
    setPostMedia(
      data.post_media.map((m: any) => ({
        ...m,
        thumbnails: [m.selectedCover || m.media_thumbnail],
        selectedCover: m.selectedCover || m.media_thumbnail,
      }))
    );
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(deleteflag)) {
      if (deleteflag === ReducerFlag.SUCCESS) {
        setOpenDeleteFeedModal(false);
        history.push("/feeds");
        FlashMessage(
          deletePostType === 1
            ? "Article deleted successfully"
            : "Post deleted successfully"
        );
      } else if (deleteflag === ReducerFlag.FAILED) {
        FlashMessage(deleteMessage, "error");
      }
      resetForm();
      dispatch(deletePostFlagReset());
    }
    // eslint-disable-next-line
  }, [deleteflag]);

  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(updateFlag)) {
      if (updateFlag === ReducerFlag.SUCCESS) {
        setOpenEditFeedModal(false);
      } else if (updateFlag === ReducerFlag.FAILED) {
        FlashMessage(updateMessage, "error");
      }
      resetForm();
      dispatch(updatePostFlagReset());
    }
    // eslint-disable-next-line
  }, [updateFlag]);

  useEffect(() => {
    if (openEditFeedModal) {
      const isContentChanged =
        stripHTMLTags(postText) !== stripHTMLTags(data.content || "");
      const isMediaChanged =
        postMedia.length !== (data.post_media?.length || 0);

      const hasRealCoverChanges = postMedia.some((asset) => {
        if (asset.media_type !== "video") return false;

        const originalAsset = data.post_media.find(
          (m: any) => m.id === asset.id
        );
        if (!originalAsset) return false;

        return (
          asset.selectedCover &&
          asset.selectedCover !== originalAsset.media_thumbnail
        );
      });

      // Check for new media uploads
      const hasNewMedia = updatedAssets.length > 0;
      setIsSaveDisabled(
        !(
          isContentChanged ||
          isMediaChanged ||
          hasRealCoverChanges ||
          hasNewMedia
        )
      );
    }
    // eslint-disable-next-line
  }, [postText, postMedia, data.content, data.post_media]);

  const feedUpdateDropDown = () => {
    if (feedMore) {
      setFeedMore(false);
    } else {
      setFeedMore(true);
    }
  };

  const removeMedia = (media_id, i) => {
    const _data = (postMedia || []).filter((row) => row.id !== media_id);
    setPostMedia(_data);
    setDeleteMedia((data: string[]) => [...data, media_id]);
    setUpdatedAssets((prevState) => prevState.filter((r) => r.id !== media_id));
  };

  const dataURLtoBlob = (dataURL: string): Blob => {
    const [header, b64] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)![1];
    const binary = atob(b64);
    const len = binary.length;
    const u8 = new Uint8Array(len);
    for (let j = 0; j < len; j++) u8[j] = binary.charCodeAt(j);
    return new Blob([u8], { type: mime });
  };

  const onSubmit = (formData: any) => {
    const payload = new FormData();

    // 1) Handle newly added media files
    let mediaIndex = 1;
    updatedAssets.forEach(({ id, file }) => {
      payload.append(`post_media_${mediaIndex}`, file);

      const asset = postMedia.find((a) => a.id === id);
      if (asset?.media_type === "video" && asset.selectedCover) {
        const coverBlob = asset.selectedCover.startsWith("data:")
          ? dataURLtoBlob(asset.selectedCover)
          : null;

        if (coverBlob) {
          payload.append(
            `cover_media_${mediaIndex}`,
            coverBlob,
            `cover_${id}.jpg`
          );
        }
      }
      mediaIndex++;
    });

    postMedia.forEach((asset) => {
      if (
        asset.media_type !== "video" ||
        updatedAssets.some((a) => a.id === asset.id)
      )
        return;

      const originalAsset = data.post_media.find((m: any) => m.id === asset.id);
      if (!originalAsset) return;

      if (
        asset.selectedCover?.startsWith("data:") &&
        asset.selectedCover !== originalAsset.selectedCover
      ) {
        const coverBlob = dataURLtoBlob(asset.selectedCover);
        const coverIndex = mediaIndex++;

        payload.append(
          `cover_media_${coverIndex}`,
          coverBlob,
          `cover_update_${asset.id}.jpg`
        );

        payload.append(`original_video_${asset.id}`, asset.media_original);
      }
    });

    if (deleteMedia.length) {
      payload.append("deleted_post_media", JSON.stringify(deleteMedia));
    }
    payload.append("post_text", formData.post_text || "");
    payload.append("id", data.id);

    dispatch(
      editFeedRequest({
        id: data.id,
        payloadData: payload,
        data: { ...data, content: formData.post_text, post_media: postMedia },
      })
    );
  };

  const onCloseEditModal = () => {
    if (
      stripHTMLTags(postText) !== stripHTMLTags(data?.content || "") ||
      postMedia.length !== data.post_media.length ||
      postMedia.some((asset) => {
        if (asset.media_type !== "video") return false;
        const originalAsset = data.post_media.find(
          (m: any) => m.id === asset.id
        );
        return (
          originalAsset &&
          asset.selectedCover &&
          asset.selectedCover !== originalAsset.media_thumbnail
        );
      }) ||
      updatedAssets.length > 0
    ) {
      setCloseEditModal(true);
    } else {
      setOpenEditFeedModal(false);
    }
  };

  // async function fetchAsBlobUrl(url: string): Promise<string> {
  //   const res = await fetch(url, { mode: 'cors' });
  //   if (!res.ok) throw new Error(`Failed to fetch video: ${res.statusText}`);
  //   const blob = await res.blob();
  //   return URL.createObjectURL(blob);
  // }
  

  // const generateThumbnails = async (
  //   urlOrFile: string | File,
  //   count = 6,
  //   maxSizeKB = 15,              
  //   maxWidth = 320   
  // ): Promise<string[]> => {
  //       const targetBytes = maxSizeKB * 1024;
  
  //   // 1. Create video element
  //   const video = document.createElement("video");
  //   video.crossOrigin = "anonymous";
  //   video.preload = "auto";
  //   video.src = typeof urlOrFile === "string"
  //     ? await fetchAsBlobUrl(urlOrFile)
  //     : URL.createObjectURL(urlOrFile);
  
  //   // 2. Wait for metadata
  //   await new Promise<void>((resolve, reject) => {
  //     video.addEventListener("loadedmetadata", () => resolve(), { once: true });
  //     video.addEventListener("error", e => reject(`Error loading video: ${e}`), { once: true });
  //     video.load();
  //   });
  
  //   if (video.duration < 2) {
  //     if (typeof urlOrFile !== "string") URL.revokeObjectURL(video.src);
  //     throw new Error("Video too short (must be >2s)");
  //   }
  
  //   // 3. Prepare capture times
  //   const interval = (video.duration - 2) / count;
  //   const times = Array.from({ length: count }, (_, i) => 1 + i * interval);
  
  //   // 4. Offscreen canvas for captures
  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");
  //   if (!ctx) throw new Error("Canvas context not available");
  
  //   const thumbs: string[] = [];
  //   for (let i = 0; i < times.length; i++) {
  //     const t = times[i];
  //     // Seek video
  //     await new Promise<void>((resolve) => {
  //       const onSeeked = () => { video.removeEventListener("seeked", onSeeked); resolve(); };
  //       video.addEventListener("seeked", onSeeked);
  //       video.currentTime = t;
  //     });
  
  //     // Scale to maxWidth
  //     const scale = Math.min(1, maxWidth / video.videoWidth);
  //     canvas.width = video.videoWidth * scale;
  //     canvas.height = video.videoHeight * scale;
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
  //     // 5. Iteratively blob at decreasing quality until < targetBytes
  //     let quality = 0.9;
  //     let blob: Blob | null = null;

  //     while (quality > 0.05) {
  //       blob = await (async (currentQuality) => {
  //         return new Promise<Blob | null>(res => 
  //           canvas.toBlob(b => res(b), "image/jpeg", currentQuality)
  //         );
  //       })(quality);
  //       if (!blob) throw new Error("Failed to create blob");
  //       console.debug(`Frame ${i+1}: size=${blob.size} bytes, quality=${quality.toFixed(2)}`);
  //       if (blob.size <= targetBytes) break;
  //       quality -= 0.05;
  //     }
  
  //     // 6. Convert to data URL
  //     const dataUrl = await new Promise<string>((res, rej) => {
  //       const reader = new FileReader();
  //       reader.onload = () => res(reader.result as string);
  //       reader.onerror = () => rej("Error reading blob");
  //       reader.readAsDataURL(blob!);
  //     });
  
  //     thumbs.push(dataUrl);
  //   }
  
  //   // Clean up if we created a blob URL
  //   if (typeof urlOrFile !== "string") {
  //     URL.revokeObjectURL(video.src);
  //   }
  
  //    return thumbs;
  // };

  //--------------------------------------------
  // Utility function to fetch with CORS headers
async function fetchWithCORS(url: string): Promise<Blob> {
  try {
    const response = await fetch(url, {
      mode: 'cors',
      headers: {
        'Range': 'bytes=0-', // Ensure we can handle partial content
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.blob();
  } catch (error) {
    console.error('Error fetching video:', error);
    throw new Error(`Failed to fetch video: ${error.message}`);
  }
}

// Main thumbnail generation function
async function generateThumbnails(
  urlOrFile: string | File,
  count = 6,
  maxSizeKB = 15,
  maxWidth = 320
): Promise<string[]> {
  const targetBytes = maxSizeKB * 1024;
  const video = document.createElement('video');
  video.crossOrigin = 'anonymous';
  video.preload = 'auto';

  let blobUrl: string | null = null;

  try {
    // Handle both URLs and File objects
    if (typeof urlOrFile === 'string') {
      // For S3 URLs, fetch with CORS headers first
      const blob = await fetchWithCORS(urlOrFile);
      blobUrl = URL.createObjectURL(blob);
      video.src = blobUrl;
    } else {
      // For File objects, create object URL directly
      blobUrl = URL.createObjectURL(urlOrFile);
      video.src = blobUrl;
    }

    // Wait for video metadata to load
    await new Promise<void>((resolve, reject) => {
      const cleanup = () => {
        video.removeEventListener('loadedmetadata', onLoad);
        video.removeEventListener('error', onError);
      };

      const onLoad = () => {
        cleanup();
        resolve();
      };

      const onError = (e: ErrorEvent) => {
        cleanup();
        reject(new Error(`Video loading error: ${e.message}`));
      };

      video.addEventListener('loadedmetadata', onLoad);
      video.addEventListener('error', onError);
    });

    // Generate random timestamps (avoid first and last 5%)
    const safeDuration = video.duration * 0.9;
    const timestamps = Array.from({ length: count }, () => 
      0.05 * video.duration + Math.random() * safeDuration
    );

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas context not available');

    const thumbnails: string[] = [];

    // Helper function to convert canvas to blob with quality
    const canvasToBlob = (quality: number): Promise<Blob> => {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob!), 'image/jpeg', quality);
      });
    };

    for (const timestamp of timestamps) {
      // Seek to timestamp
      await new Promise<void>((resolve) => {
        const onSeeked = () => {
          video.removeEventListener('seeked', onSeeked);
          resolve();
        };
        video.addEventListener('seeked', onSeeked);
        video.currentTime = timestamp;
      });

      // Calculate dimensions
      const scale = Math.min(1, maxWidth / video.videoWidth);
      canvas.width = video.videoWidth * scale;
      canvas.height = video.videoHeight * scale;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Optimize quality and size
      let quality = 0.9;
      let dimensions = 1;
      let blob: Blob;

      // First try adjusting quality only
      do {
        blob = await canvasToBlob(quality);
        if (blob.size > targetBytes) {
          quality = Math.max(0.1, quality - 0.1);
        }
      } while (blob.size > targetBytes && quality > 0.1);

      // If still too big, reduce dimensions
      if (blob.size > targetBytes) {
        dimensions = 0.8;
        do {
          canvas.width = video.videoWidth * dimensions;
          canvas.height = video.videoHeight * dimensions;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          blob = await canvasToBlob(0.7); // Fixed decent quality
          dimensions = Math.max(0.3, dimensions - 0.1);
        } while (blob.size > targetBytes && dimensions > 0.3);
      }

      // Convert to data URL
      const dataUrl = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });

      thumbnails.push(dataUrl);
    }

    return thumbnails;
  } finally {
    // Clean up object URL if we created one
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl);
    }
  }
}

// React component integration
// const openCoverModal = async (index: number) => {
//   const asset = postMedia[index];
//   if (asset.media_type === "video") {
//     try {
//       setPostMedia(prev => prev.map((a, i) => 
//         i === index ? { ...a, loadingThumbnails: true } : a
//       ));

//       // Generate thumbnails with cache busting for S3 URLs
//       const cacheBusterUrl = asset.media_original.includes('?')
//         ? `${asset.media_original}&t=${Date.now()}`
//         : `${asset.media_original}?t=${Date.now()}`;

//       const frames = await generateThumbnails(cacheBusterUrl, 6);
      
//       const thumbs = asset.selectedCover
//         ? [asset.selectedCover, ...frames.filter(f => f !== asset.selectedCover).slice(0, 5)]
//         : frames.slice(0, 6);

//       setPostMedia(prev => prev.map((a, i) =>
//         i === index ? { 
//           ...a, 
//           thumbnails: thumbs, 
//           selectedCover: thumbs[0],
//           loadingThumbnails: false 
//         } : a
//       ));
      
//       setCurrentVideoIndex(index);
//       setCoverModalOpen(true);
//     } catch (error) {
//       console.error('Error generating thumbnails:', error);
//       FlashMessage("Failed to generate thumbnails. Please check CORS configuration.", "error");
//       setPostMedia(prev => prev.map((a, i) => 
//         i === index ? { ...a, loadingThumbnails: false } : a
//       ));
//     }
//   }
// };
  // async function generateThumbnails(
  //   urlOrFile: string | File,
  //   count = 6,
  //   maxSizeKB = 15,
  //   maxWidth = 320
  // ): Promise<string[]> {
  //   const targetBytes = maxSizeKB * 1024;
  //   const video = document.createElement('video');
  //   video.crossOrigin = 'anonymous';
  //   video.preload = 'auto';
  //   video.src = typeof urlOrFile === 'string'
  //   ? urlOrFile
  //   : URL.createObjectURL(urlOrFile);
  
  
  //   // wait for metadata
  //   await new Promise<void>((res, rej) => {
  //     video.addEventListener('loadedmetadata', () => res(), { once: true });
  //     video.addEventListener('error', e => rej(e), { once: true });
  //     video.load();
  //   });
  //   if (video.duration < 2) {
  //     if (typeof urlOrFile !== 'string') URL.revokeObjectURL(video.src);
  //     throw new Error('Video too short (must be >2s)');
  //   }
  
  //   // compute capture times
  //   const interval = (video.duration - 2) / count;
  //   const times = Array.from({ length: count }, (_, i) => 1 + i * interval);
  
  //   const canvas = document.createElement('canvas');
  //   const ctx = canvas.getContext('2d')!;
  //   const thumbs: string[] = [];
  
  //   // helper: blobify JPEG at given quality
  //   const toJpegBlob = (q: number) => new Promise<Blob>(res =>
  //     canvas.toBlob(b => res(b!), 'image/jpeg', q)
  //   );
  
  //   for (let t of times) {
  //     // seek to time t
  //     await new Promise<void>(res => {
  //       const onSeek = () => {
  //         video.removeEventListener('seeked', onSeek);
  //         res();
  //       };
  //       video.addEventListener('seeked', onSeek);
  //       video.currentTime = t;
  //     });
  
  //     // draw scaled frame
  //     const scale = Math.min(1, maxWidth / video.videoWidth);
  //     canvas.width = video.videoWidth * scale;
  //     canvas.height = video.videoHeight * scale;
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
  //     // binary-search quality between [0, 1]
  //     let low = 0, high = 1;
  //     let bestBlob = await toJpegBlob(high);
  //     if (bestBlob.size > targetBytes) {
  //       // even quality=1 too big? start high=1 and low=0
  //       // we'll shrink quality
  //     } else {
  //       // quality=1 under target, we can try higher—but max is 1
  //     }
  
  //     // perform ~8 iterations
  //     for (let i = 0; i < 8; i++) {
  //       const mid = (low + high) / 2;
  //       const blob = await toJpegBlob(mid);
  //       if (blob.size > targetBytes) {
  //         // too big → lower quality
  //         high = mid;
  //       } else {
  //         // under target → move low up, remember this blob
  //         low = mid;
  //         bestBlob = blob;
  //       }
  //     }
  
  //     // if still too big, shrink dimensions further
  //     if (bestBlob.size > targetBytes) {
  //       let currWidth = canvas.width;
  //       while (bestBlob.size > targetBytes && currWidth > 50) {
  //         currWidth = Math.floor(currWidth * 0.8);
  //         const factor = currWidth / video.videoWidth;
  //         canvas.width = currWidth;
  //         canvas.height = video.videoHeight * factor;
  //         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //         bestBlob = await toJpegBlob(low);
  //       }
  //     }
  
  //     // convert blob → dataURL
  //     const dataUrl = await new Promise<string>((res, rej) => {
  //       const reader = new FileReader();
  //       reader.onload = () => res(reader.result as string);
  //       reader.onerror = () => rej('read error');
  //       reader.readAsDataURL(bestBlob);
  //     });
  
  //     thumbs.push(dataUrl);
  //   }
  
  //   if (typeof urlOrFile !== 'string') URL.revokeObjectURL(video.src);
  //   return thumbs;
  // }
    
  useEffect(() => {
    if (!openEditFeedModal) return;

    postMedia.forEach((asset, i) => {
      if (asset.media_type === "video" && !asset.thumbnails) {
        generateThumbnails(asset.media_original, 6)
          .then((frames) => {
            const thumbs = asset.selectedCover
              ? [asset.selectedCover, ...frames.slice(0, 5)]
              : frames.slice(0, 6);

            setPostMedia((prev) =>
              prev.map((x, j) =>
                j === i
                  ? { ...x, thumbnails: thumbs, selectedCover: thumbs[0] }
                  : x
              )
            );
          })
          .catch((e) => {
            FlashMessage("Failed to generate thumbnails", "error");
          });
      }
    });
    // eslint-disable-next-line
  }, [openEditFeedModal]);

  const openCoverModal = (index: number) => {
    const asset = postMedia[index];
     if (asset.media_type === "video") {
      setPostMedia(prev => prev.map((a, i) => 
        i === index ? { ...a, loadingThumbnails: true } : a
      ));
      // Generate thumbnails with cache busting for S3 URLs
      const cacheBusterUrl = asset.media_original.includes('?')
        ? `${asset.media_original}&t=${Date.now()}`
        : `${asset.media_original}?t=${Date.now()}`;
      if (!asset.thumbnails || asset.thumbnails.length < 6) {
        generateThumbnails(cacheBusterUrl || asset.media_thumbnail, 6)
          .then((frames) => {
               const thumbs = asset.selectedCover
              ? [
                  asset.selectedCover,
                  ...frames
                    .filter((f) => f !== asset.selectedCover)
                    .slice(0, 5),
                ]
              : frames.slice(0, 6);

            setPostMedia((prev) =>
              prev.map((a, i) =>
                i === index
                  ? { ...a, thumbnails: thumbs, selectedCover: thumbs[0],loadingThumbnails: false  }
                  : a
              )
            );
          })
          .catch(() => {
            FlashMessage("Failed to generate thumbnails", "error");
            setPostMedia(prev => prev.map((a, i) => 
              i === index ? { ...a, loadingThumbnails: false } : a
            ));
          });
      }else{
        setPostMedia(prev => prev.map((a, i) =>
          i === index ? { ...a, loadingThumbnails: false } : a
        ));
      }
    }
    // finally, open the modal
    setCurrentVideoIndex(index);
    setCoverModalOpen(true);
  };

  // Inside your FeedBodyHeader component:
  const onUpdateMedia = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    // prevent >4 items
    if (postMedia.length + files.length > 4) {
      FlashMessage("Max 4 files can be uploaded", "error");
      e.target.value = "";
      return;
    }

    const newAssets: MediaAsset[] = [];
    for (const file of files) {
      const id = uuid();
      const url = URL.createObjectURL(file);
      const asset: MediaAsset = {
        id,
        media_type: file.type.startsWith("video/") ? "video" : "image",
        media_thumbnail: url,
        media_original: url,
      };

      if (asset.media_type === "video") {
        try {
          // generate exactly 6 frames
          const frames = await generateThumbnails(file, 6);
                asset.thumbnails = frames.slice(0, 6);
          asset.selectedCover = frames[0];
        } catch {
          FlashMessage("Error generating video thumbnails", "error");
        }
      }

      newAssets.push(asset);
      setUpdatedAssets((prev) => [...prev, { id, file }]);
    }

    setPostMedia((prev) => [...prev, ...newAssets]);
    e.target.value = "";
  };

  const resetForm = () => {
    setUpdatedAssets([]);
    setDeleteMedia([]);
  };

  const handelRedirectProfile = () => {
    if (data?.is_company && data?.user_slug) {
      let redirect = "";
      if (data?.is_company === 1) {
        redirect = appRoutes.candidatePublicProfile.generateFullPath(
          data.user_slug
        );
      } else if (data?.is_company === 2) {
        redirect = appRoutes.CompanyPublicView.generatePath(data.user_slug);
      }

      if (redirect) {
        openUrlInNewTab(redirect);
      }
    }
  };

  const handleCoverSelect = (thumb: string) => {
    if (currentVideoIndex === null) return;
    setPostMedia((prev) =>
      prev.map((asset, i) =>
        i === currentVideoIndex ? { ...asset, selectedCover: thumb } : asset
      )
    );
    setCoverModalOpen(false);
    setCurrentVideoIndex(null);
  };

  return (
    <>
      <div className="feed-header">
        <div
          className="feed-header-info cursor-pointer"
          onClick={() => handelRedirectProfile()}
        >
          <FeedLogo profileLogo={data?.post_user_image} name={data.post_user} />
          <div className="feed-title-info">
            <h2>{data?.post_user}</h2>
            <span>{convertUTCToLocal(data.created_at)} ago</span>
          </div>
        </div>
        {currentUser?.id === data.user_id ? (
          <div
            className="feed-header-more"
            onClick={() => feedUpdateDropDown()}
          >
            <Image src={dots} alt="postImage" className="dot-icon" />
            {feedMore && (
              <ul>
                {postType === 1 ? (
                  <li
                    onClick={() =>
                      openUrlInNewTab(
                        appRoutes.articleUpdate.generatePath(data?.slug)
                      )
                    }
                  >
                    Edit
                  </li>
                ) : (
                  <li onClick={() => setOpenEditFeedModal(true)}>Edit </li>
                )}
                {/* <li>Hide Post</li> */}

                <li
                  onClick={() => {
                    setOpenDeleteFeedModal(true);
                  }}
                >
                  Delete
                </li>
              </ul>
            )}
          </div>
        ) : (
          <div
            className="feed-header-more"
            onClick={() => feedUpdateDropDown()}
          >
            <Image src={dots} alt="postImage" className="dot-icon" />
            {feedMore && (
              <ul>
                <li onClick={() => setOpenReport(true)}>Report Post</li>
              </ul>
            )}
          </div>
        )}
      </div>

      {openReport && (
        <Report
          openReports={true}
          referenceId={postId}
          type="post"
          onClose={() => {
            setOpenReport(false);
          }}
        />
      )}
      {/* Edit Feed Modal here  */}
      {openEditFeedModal && (
        <Modal
          className="feed-edit-modal"
          visible={openEditFeedModal}
          closeOnBackDrop={true}
          closeButton={true}
          size="large"
          loading={editLoading}
          title="Edit Post"
          onClose={() => onCloseEditModal()}
        >
          <div className="feed-input-wrapper">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-textArea wysiwyg-data">
                <RichTextEditor
                  name="post_text"
                  validationObj={errors}
                  control={control}
                  rules={{
                    validate: {
                      validLength: (value) => {
                        const tmpText = stripHTMLTags(value || "");
                        return (
                          tmpText.length <= 3000 ||
                          "Can not exceed more then 3000 characters"
                        );
                      },
                    },
                  }}
                  useMention
                />
                <FeedLogo
                  profileLogo={data.post_user_image}
                  name={data.post_user}
                />
              </div>
              {_.get(errors, "post_text.message") && (
                <ErrorTextHelper text={_.get(errors, "post_text.message")} />
              )}
              <span className="text-length">{postTextLength}/3000</span>
              {postMedia?.length > 0 && (
                // <div className="feed-media-wrapper">
                <div className="feed-img-wrapper">
                  {postMedia?.map((media, i) => {
                    return (
                      <div className="img-wrapper" key={i}>
                        {media.media_type === "image" ? (
                          <Image
                            src={media?.media_thumbnail}
                            alt="post media"
                          />
                        ) : (
                          <>
                            {" "}
                            <ReactPlayer
                              width="100%"
                              height="100%"
                              url={media?.media_original}
                              playing={false}
                              controls={true}
                            />
                            <span
                              onClick={() => openCoverModal(i)}
                              color="secondary"
                              className="cover-btn"
                            >
                              Edit Cover
                            </span>
                          </>
                        )}
                        <span
                          className="media-close"
                          onClick={() => removeMedia(media.id, i)}
                        >
                          {/* <DeleteIcon /> */}
                          <CancelOut />
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="feed-button-wrapper">
                <FeedButton
                  svg={cameraIcon}
                  id="edit_button"
                  name="post_media"
                  type="file"
                  form={form}
                  onUploadImage={onUpdateMedia}
                  value="post_media"
                  accept="image/png, image/gif, image/bmp, image/jpeg ,video/*"
                />
                <div className="edit-btn-wrapper">
                  <Button
                    className="submit-btn"
                    loading={editLoading}
                    disabled={
                      // postText.length > 0 || postMedia.length > 0 ? false : true
                      isSaveDisabled
                    }
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    className="submit-btn"
                    color="secondary"
                    onClick={() => onCloseEditModal()}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* Edit Feed Modal ends here  */}

      {/* Edit Feed Confirm Modal here */}
      {closeEditModal && (
        <Modal
          className="feed-edit-modal feed-delete-modal dicard-modal "
          visible={true}
          closeOnBackDrop={true}
          closeButton={true}
          size="medium"
          loading={editLoading}
          title="Discard Feed"
          onClose={() => setCloseEditModal(false)}
        >
          <p>
            You have unsaved changes. Are you sure you want to discard changes?
          </p>
          <Button
            color="primary"
            className="submit-btn"
            onClick={() => setCloseEditModal(false)}
          >
            Keep Posting
          </Button>
          <Button
            color="secondary"
            className="submit-btn"
            onClick={() => {
              setCloseEditModal(false);
              setOpenEditFeedModal(false);
              setPostMedia(data.post_media);
            }}
          >
            Discard
          </Button>
        </Modal>
      )}

      {coverModalOpen && currentVideoIndex !== null && (
        <Modal
          className="post-cover-modal"
          title="Select Cover Image"
          visible
          onClose={() => setCoverModalOpen(false)}
        >
          {/* <div className="cover-options-container">
            {postMedia[currentVideoIndex].thumbnails!.map((thumb, idx) => (
              <img
                alt="no-cover"
                key={idx}
                src={thumb}
                onClick={() => handleCoverSelect(thumb)}
                className={
                  postMedia[currentVideoIndex].selectedCover === thumb
                    ? "cover-option-img selected"
                    : "cover-option-img"
                }
              />
            ))}
          </div> */}
          <div className="cover-options-container">
      {postMedia[currentVideoIndex].loadingThumbnails ? (
          <CircularProgress color="secondary" className="circular-progress" />
      ) : (
        postMedia[currentVideoIndex].thumbnails?.map((thumb, idx) => (
          <img
            alt="no-cover"
            key={idx}
            src={thumb}
            onClick={() => handleCoverSelect(thumb)}
            className={
              postMedia[currentVideoIndex].selectedCover === thumb
                ? "cover-option-img selected"
                : "cover-option-img"
            }
          />
        ))
      )}
    </div>
        </Modal>
      )}
      {/* Edit Feed Confirm Modal ends here */}

      {/* Delete Feed Confirm Modal here */}
      <ConfirmDialog
        visible={openDeleteFeedModal}
        title={postType === 1 ? "Remove article" : "Remove post"}
        onCancel={() => setOpenDeleteFeedModal(false)}
        bodyText={
          postType === 1
            ? "Do you really want to remove the article?"
            : "Do you really want to remove the post?"
        }
        onConfirm={() => {
          dispatch(deleteFeedRequest(data.id));
          setOpenDeleteFeedModal(false);
        }}
        loading={deleteLoading}
        confirmText="Confirm"
      />
      {/* Delete Feed Confirm Modal ends here */}
    </>
  );
};

export default FeedBodyHeader;
